<template>
  <v-overlay :value="reward.overlay" style="z-index:100">
    <v-img
      @click="reward.overlay = false"
      :src="reward.src"
      style="animation: zoominout 1s infinite;"
    ></v-img>
    <div
      @click="reward.overlay = false"
      style="font-size:15px; animation: zoominout 1s infinite;text-align:center"
      v-if="reward.name == 'Email'"
    >
      <span style="font-size:30px">Congratulations!</span>
    </div>
    <div
      @click="reward.overlay = false"
      style="font-size:15px; animation: zoominout 1s infinite;text-align:center"
      v-if="reward.name == 'Beer'"
    >
      <span style="font-size:30px">Free {{customer.reward||'Beer'}}</span>
      <br />Hurray!
      <br />
      You have won a free {{customer.reward||'beer'}}.
      <br />Show this message to a cashier
      <br />and enjoy your cool reward
    </div>
    <div
      v-else
      @click="reward.overlay = false"
      style="font-size:50px; animation: zoominout 1s infinite;text-align:center"
    >+{{reward.value}}⭐</div>
  </v-overlay>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState(["customer"]),

    reward: {
      get() {
        return this.$store.state.reward;
      },
      set(val) {
        return this.$store.commit("setReward", val);
      }
    }
  }
};
</script>


